import './load_more.scss';
import { get_el, create_div } from 'js/utils';
import Hooks from 'classes/Hooks';

export default class Load_More {
    
    constructor(container, args = {}){

        this.container = get_el(container);
        this.args = args;
        this.showposts = parseInt(args.showposts);

        this.hooks = new Hooks([
            'trigger',
        ]);

        this.init(args);
    }

    init(args = {}){

        this.state = 'init';

        this.total = parseInt(args.total);
        this.count = parseInt(args.count);
        this.offset = this.count;
        
        if( this.total > this.count ) {
            this.init_indicator();
        }
    }
    
    init_indicator(){

        const indicator = create_div('load_more_indicator');
        indicator.innerHTML = '<i></i><i></i><i></i>';
        this.container.after(indicator);
        
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.trigger();
                }
            });
        })
        
        observer.observe(indicator);

        indicator.clear = ()=>{
            if( !indicator ) return;
            observer.unobserve(indicator);
            indicator.remove();
        }

        this.indicator = indicator;
    }

    trigger(){

        if( this.state === 'loading' ) return;
        
        this.hooks.do('trigger', this.offset)

        this.update(); 
    }

    update(){

        this.offset += this.showposts;

        if( this.offset >= this.total ) {
            this.end();
        }
    }

    update_args(args){
        
        if( this.indicator ) {
            this.indicator.clear();
        }
        
        this.init(args);
    }
    
    end(){
        this.state = 'end';
        
        if( this.indicator ) {
            this.indicator.clear();
        }
    }

    loading(){
        this.indicator.classList.add('loading');
        this.state = 'loading';
    }

    loading_end(){
        if( !this.indicator ) return;
        this.indicator.classList.remove('loading');
        this.state = 'idle';
    }
    
}